import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-icon-sidebar-arrow',
  templateUrl: './icon-sidebar-arrow.component.html',
  styleUrls: ['./icon-sidebar-arrow.component.scss']
})
export class IconSidebarArrowComponent implements OnInit {

  @Input() cssClass = '';

  constructor() { }

  ngOnInit() {
  }

}
